import axios from 'axios'

import type { SimilarityReturn } from '../ProductCard/ProductCardReturn'

interface Props {
  setMobileSimilars: React.Dispatch<React.SetStateAction<SimilarityReturn>>
  productId: string
}

export const getSimilarProductsCached = async ({
  setMobileSimilars,
  productId,
}: Props) => {
  await axios
    .get('/api/getSimilarProduct', {
      params: {
        productId,
      },
    })
    .then((response) => setMobileSimilars(response.data))
    .catch((error) => {
      console.error(error)
    })
}
